import axiosInstance from "../Axios-Config/Axios-Config";
import { ErrorToast } from "../components/ToastComponent/ErrorToast";
import { SETALLREVIEW } from "../redux/features/store";
import Konsole from "../utils/konsole/Konsole";
import { Dispatch } from "redux";
export const reviewAddApi = async (payload: any) => {
  try {
    const { data }: any = await axiosInstance.post("/reviews", payload);

    if (data.success) {
      // SuccessToast(data.message);
      return true;
    } else {
      ErrorToast(data.message);
      return false;
    }
  } catch (error: any) {
    ErrorToast(error.message);
    return false;
  }
};

export async function getAllReview(dispatch: Dispatch, storeId: any) {
  try {
    const response = await axiosInstance.get(`get/reviews?store_id=${storeId}`);

    Konsole.log('responseresponse', response);
    const reviewData = response?.data?.reviews?.data
    dispatch(SETALLREVIEW(reviewData));
  } catch (error: any) {
    Konsole.log('error', error)
    dispatch(SETALLREVIEW([]));
  }
}
// export default reviewAddApi;
